import React, { useEffect, useState } from 'react'
import { Link, matchPath } from 'react-router-dom'
import logo from "../../assets/Logo/Logo-Full-Light.png"
import {NavbarLinks} from "../../data/navbar-links"
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {AiOutlineShoppingCart} from "react-icons/ai"
import ProfileDropDown from '../core/Auth/ProfileDropDown'
import { apiConnector } from '../../services/apiconnector'
import { categories } from '../../services/apis'
import { FaAngleDown } from "react-icons/fa6";
import { ACCOUNT_TYPE } from '../../utils/constants'

const Navbar = () => {
    const {token} = useSelector( (state) => state.auth);
    const {user} = useSelector( (state) => state.profile);
    const {totalItems} = useSelector( (state) => state.cart);
    const location = useLocation();

    const [subLinks, setSubLinks] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchSublinks = async () => {
        try{
            const result = await apiConnector("GET",categories.CATEGORIES_API);
            setSubLinks(result?.data?.data);

        }catch(error){
            console.log("Could not fetch the category list");
        }
    }


    useEffect( () => {
        fetchSublinks();
    },[])

    const matchRoute = (route) => {
        return matchPath({path:route}, location.pathname);
    }

  return (
    <div className={`flex h-14 items-center justify-center border-b-[1px] border-b-richblack-700
    ${location.pathname !== "/" ? "bg-richblack-800": ""} transition-all duration-200`}>
        <div className='flex w-11/12 max-w- max-w-maxContent items-center justify-between'>
            {/* Image */}
            <Link to="/">
                <img src={logo} alt="logo" width={160} height={32} loading='lazy'/>
            </Link>

            {/* Nav Links */}
            <nav className='hidden md:block'>
                <ul className='flex gap-x-6 text-richblack-25'>
                {
                        NavbarLinks.map( (link, index) => {
                            return (
                                <li key={index}>
                                    {
                                        link.title === "Catalog" ? 
                                        (
                                            <>

                                                <div className={`relative flex flex-row items-center gap-2 group cursor-pointer
                                                ${matchRoute("/catalog/:catalogName") ? "text-yellow-25" : "text-richblack-25"}
                                                `}>
                                                    <p>{link.title}</p>
                                                    <FaAngleDown />

                                                    <div className='invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 
                                                    opacity-0 transition-all duration-150 group-hover:visible group-hover:opacity-100 group-hover:translate-y-[1.65em] 
                                                    lg:w-[300px] translate-x-[-50%] translate-y-[1em]'>
                                                        <div className='absolute translate-x-[80%] translate-y-[-40%] select-none left-[50%] top-0 h-6 w-6 rotate-45 rounded bg-richblack-5 '>
                                                        </div>

                                                        {
                                                            subLinks.length ? (
                                                                <>
                                                                    {subLinks
                                                                        ?.filter(
                                                                            (subLink) => subLink?.courses?.length > 0
                                                                        ) 
                                                                        ?.map( (subLink, i) => (
                                                                        <Link 
                                                                            to={`/catalog/${subLink.name
                                                                                .split(" ")
                                                                                .join("-")
                                                                                .toLowerCase()
                                                                            }`} 
                                                                            className='rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50'
                                                                            key={i}>
                                                                            <p className='w-full text-richblack-900'>{subLink.name}</p>
                                                                        </Link>
                                                                    ))}
                                                                </>
                                                                
                                                            ) : (<p className='text-center text-richblack-900'>No Courses Found</p>)
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        ) : 
                                        (
                                            <Link to={link?.path}>
                                                <p className={`${matchRoute(link?.path) ? "text-yellow-25" : "text-richblack-25"}`}>
                                                    {link.title}
                                                </p>
                                            </Link>
                                        )
                                    }
                                </li>
                            )
                        })
                    }
                </ul>
            </nav>

            {/* Login/SignUp/Dashboard */}
            <div className='md:flex gap-x-4 items-center hidden'>
                {
                    user && user?.accountType !== ACCOUNT_TYPE.INSTRUCTOR && (
                        <Link to={"/dashboard/cart"} className='relative'>
                            <AiOutlineShoppingCart className='text-2xl text-richblack-100'/>
                            {
                                totalItems > 0 && (
                                    <span className='absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100'>
                                        {totalItems}
                                    </span>
                                )
                            }
                        </Link>
                    )
                }
                {
                    token === null && (
                        <Link to={'/login'}>
                            <button className='border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100 rounded-md'>
                                Log in
                            </button>
                        </Link>
                    )
                }
                {
                    token === null && (
                        <Link to={"/signup"}>
                            <button className='border border-richblack-700 bg-richblack-800 px-[12px] py-[8px] text-richblack-100 rounded-md'>
                                Sign Up
                            </button>
                        </Link>
                    )
                }
                {
                    token !== null && <ProfileDropDown />
                }
            </div>
        </div>
    </div>
  )
}

export default Navbar
